// Derived-rate field enums mirror the API contract used by the ARI promo
// endpoint; kept module-local so components/ does not depend on pages/.
export const DERIVED_FROM_TYPE = {
  BASE_RATEPLAN: "BASE_RATEPLAN",
  DERIVED_RATE: "DERIVED_RATE",
};

export const PROMOTIONS_CARD_TITLE = "Promotions";

// Deepest nesting level the stacked list renders; rates nested further are
// hidden entirely (and excluded from the count badge). Keep in sync with the
// depth loop in stacked-promotion-summary.scss ($sp-max-depth).
// Total we show DRs till L4 as 2 levels are above where nesting starts
export const MAX_STACK_INDENT_DEPTH = 2;

export const DOW_DISCOUNT_TYPE = "Discount by Day of Week";
